/* eslint-disable react-hooks/exhaustive-deps */
import {FC, useContext, useState, useEffect} from 'react'
import {useQuery} from 'react-query'
import {
  createResponseContext,
  initialQueryResponse,
  initialQueryState,
  PaginationState,
  serializeObjectToQueryString,
  stringifyRequestQuery,
} from '../../../../../_metronic/helpers'
import {getWebhooksItemsList} from './_requests'
import {useQueryRequest} from './QueryRequestProvider'
import { useLocation } from 'react-router-dom'
import { useQueryParams } from '../../../../../utils/utils'
import { defaultLimit } from '../../../../components/Table/components/pagination/UsersListPagination'
import { SORT_PARAMS } from '../../../../components/Table/table/columns/HeaderWithSort'
import { useErrorHandler } from '../../../../../hooks/useErrorsHandler'

const QueryResponseContext = createResponseContext<any>(initialQueryResponse)
const QueryResponseProvider: FC = ({children}) => {
  const {state} = useQueryRequest()
  const {statuses, webhookUrls, operatorIds, dateMin, dateMax, page, limit, order} = useQueryParams()
  const location = useLocation();
  const [query, setQuery] = useState<string>(stringifyRequestQuery(state))
  const [response, setResponse] = useState<any>();
  const [errorMessage, setErrorMessage] = useState<string>('')
  const {
    isFetching,
    refetch,
    data: result,
    error
  } = useQuery(
    `get-burning-items`,
    async () => {    
      setErrorMessage('')  
      const newQuery = serializeObjectToQueryString({statuses, webhookUrls, operatorIds, dateMin, dateMax,  limit: limit || defaultLimit, page: page || 1, order: order || SORT_PARAMS.ASC});

      return await getWebhooksItemsList(newQuery)
    },
    {cacheTime: 0, retry: false, keepPreviousData: true, refetchOnWindowFocus: false}
  )

  useEffect(() => {
    setResponse(result)
  }, [result])

  useErrorHandler(error, setErrorMessage, setResponse)

  useEffect(() => {
    refetch()
  }, [location]);

  return (
    <QueryResponseContext.Provider value={{isLoading: isFetching, refetch, response, query, total: result?.total, errorMessage }}>
      {children}
    </QueryResponseContext.Provider>
  )
}

const useQueryResponse = () => useContext(QueryResponseContext)

const useQueryResponseData = () => {
  const {response} = useQueryResponse()
  if (!response) {
    return []
  }

  return response?.data || []
}

const useQueryResponsePagination = () => {
  const defaultPaginationState: PaginationState = {
    links: [],
    ...initialQueryState,
  }

  const {response} = useQueryResponse()
  if (!response || !response.payload || !response.payload.pagination) {
    return defaultPaginationState
  }

  return response.payload.pagination
}

const useQueryResponseLoading = (): boolean => {
  const {isLoading} = useQueryResponse()
  return isLoading
}

export {
  QueryResponseProvider,
  useQueryResponse,
  useQueryResponseData,
  useQueryResponsePagination,
  useQueryResponseLoading,
}
